import Controller from '@ember/controller';
import { action, computed, get, set, setProperties } from '@ember/object';
import { alias, filterBy } from '@ember/object/computed';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import { camelize } from '@ember/string';
import { task } from 'ember-concurrency';

export default Controller.extend({
  currentUser: service(),
  router: service(),
  store: service(),

  showNoFileChosenErrorMessage: false,
  showSelectAtLeastOneFileErrorMessage: false,
  uploading: false,
  error: null,

  uploadFiles: alias('model.uploadFiles'),

  reset() {
    setProperties(this, {
      showNoFileChosenErrorMessage: false,
      showSelectAtLeastOneFileErrorMessage: false,
      uploading: false,
      error: null,
      uploadFilesCompleteStatus: [],
    });
  },

  showUploadAllDropdown: computed('currentUser.organizationId', function () {
    return this.currentUser.organizationId !== '366'; // RUF
  }),

  hasNoErrors: computed('uploadFiles.@each.fileChosen', function () {
    let noFileChosen = this.uploadFiles.find((uploadFile) => {
      return !get(uploadFile, 'fileChosen');
    });
    return noFileChosen == null;
  }),

  removeEmptyOptionalFiles() {
    let emptyOptionalFiles = this.uploadFiles.filter((uploadFile) => {
      return !get(uploadFile, 'required') && !get(uploadFile, 'fileChosen');
    });

    this.model.uploadFiles = this.model.uploadFiles.filter((uploadFile) => {
      return !emptyOptionalFiles.includes(uploadFile);
    });
  },

  uploadFilesWithFileChosen: filterBy('uploadFiles', 'fileChosen'),
  uploadFilesCompleteStatus: [],

  checkIfAllFileUploadsAreComplete() {
    let uploadFiles = this.uploadFiles;
    let completedFilesLength = this.uploadFilesCompleteStatus.filter((i) => {
      return i.completed;
    }).length;

    if (get(uploadFiles, 'length') === completedFilesLength) {
      this.processUpload.perform();
    }
  },

  processUpload: task(function* () {
    try {
      let uploadFiles = this.uploadFiles;
      let processUpload = this.store.createRecord('admin/process-upload', {
        uploadAll: get(this, 'model.changeset.uploadAll'),
      });

      uploadFiles.forEach((uploadFile) => {
        let argKey = camelize(get(uploadFile, 'processArgKey'));
        if (get(uploadFile, 'processArgIsArray')) {
          let val = get(processUpload, argKey) || [];
          val.push(get(uploadFile, 'key'));
          set(processUpload, argKey, val);
        } else {
          set(processUpload, argKey, get(uploadFile, 'key'));
        }
      });
      yield processUpload.save();
      this.router.transitionTo('admin.upload.complete');
    } catch (error) {
      setProperties(this, {
        error,
        uploading: false,
      });
    }
  }),

  upload: action(function () {
    if (get(this, 'uploadFilesWithFileChosen.length') === 0) {
      set(this, 'showSelectAtLeastOneFileErrorMessage', true);
      return;
    }

    setProperties(this, {
      showSelectAtLeastOneFileErrorMessage: false,
      uploading: true,
    });
    this.removeEmptyOptionalFiles();
    // have to give time for the removed optional files components to completely destroy
    next(() => {
      set(this, 'showNoFileChosenErrorMessage', true);
      if (this.hasNoErrors) {
        set(
          this,
          'uploadFilesCompleteStatus',
          this.uploadFiles.map((uploadFile) => {
            return {
              uploadFile,
              completed: false,
            };
          }),
        );
        get(this, 'model.beginUploadEventBus').beginUpload();
      } else {
        set(this, 'uploading', false);
      }
    });
  }),

  handleUploadComplete: action(function (uploadFile) {
    let item = this.uploadFilesCompleteStatus.find((i) => {
      return i.uploadFile === uploadFile;
    });
    if (item) {
      item.completed = true;
    }
    this.checkIfAllFileUploadsAreComplete();
  }),

  handleUploadError: action(function (error) {
    set(this, 'error', error);
  }),

  handleUploadCancelled: action(function () {
    set(this, 'error', new Error('upload cancelled'));
  }),
});
